import { Component, Input, OnInit } from '@angular/core';
import { get as _get, startsWith as _startsWith } from 'lodash';

import { ShopCardHours } from '../../models/map.models';

@Component({
  selector: 'drp-shop-card-hours',
  templateUrl: './shop-card-hours.component.html',
  styleUrls: ['./shop-card-hours.component.scss'],
  standalone: false
})
export class ShopCardHoursComponent implements OnInit {
  @Input() shopHours;
  public formattedHours = [];
  public singleFormattedHours: string;
  constructor() {}

  ngOnInit() {
    if (this.shopHours.length > 1) {
      this.shopHours.forEach(day => {
        const concatedHours: ShopCardHours = { day: '', hours: '' };
        if (day.openHour && day.closeHour) {
          concatedHours.day = day.dayOfWeek.toString().substring(0, 3);
          concatedHours.hours =
            this.convertFromMilitary(_get(day, 'openHour')) +
            '-' +
            this.convertFromMilitary(_get(day, 'closeHour'));
          this.formattedHours.push(concatedHours);
        }
      });
    } else if (this.shopHours.length === 1) {
      this.singleFormattedHours = this.shopHours[0]
        .replace(/SUNDAY/gi, 'Sun')
        .replace(/MONDAY/gi, 'Mon')
        .replace(/TUESDAY/gi, 'Tue')
        .replace(/WEDNESDAY/gi, 'Wed')
        .replace(/THURSDAY/gi, 'Thu')
        .replace(/FRIDAY/gi, 'Fri')
        .replace(/SATURDAY/gi, 'Sat')
        .replace(/AM/gi, 'am')
        .replace(/PM/gi, 'pm');
    }
  }

  private convertFromMilitary(time: String) {
    const militaryHour = parseInt(time.substring(0, 2), 10);
    let amPm = 'PM';
    if (militaryHour % 12 === militaryHour) {
      amPm = 'AM';
    }

    let hour = (parseInt(time.substring(0, 2), 10) % 12).toString();
    if (hour === '0') {
      hour = '12';
    }
    const min = time.substring(2, 4);
    return hour + ':' + min + amPm;
  }
}
